import React from 'react';
import { makeStyles, Tooltip as MuiTooltip } from '@material-ui/core';

import { COLOR } from 'Components/Theme';
import { compensateCssZoomModifier } from 'Components/Theme/uiScale';

const useStyles = makeStyles(() => ({
  tooltip: {
    backgroundColor: COLOR.buttonText,
    fontSize: '12px',
    lineHeight: '16px',
    padding: '8px 12px',
    borderRadius: '4px',
  },
  arrow: {
    color: COLOR.buttonText,
  },
}));

// Report pages are scaled with CSS `zoom` (see Components/Theme/uiScale). The modifier
// corrects Popper's position under zoom. Kept as a module constant so MUI's memoized
// PopperProps stay stable between renders.
const ZOOM_SAFE_POPPER_PROPS = {
  modifiers: { compensateCssZoom: compensateCssZoomModifier },
};

const Tooltip = ({ PopperProps, ...props }) => {
  const classes = useStyles();
  return (
    <MuiTooltip
      classes={classes}
      PopperProps={
        PopperProps ? { ...ZOOM_SAFE_POPPER_PROPS, ...PopperProps } : ZOOM_SAFE_POPPER_PROPS
      }
      {...props}
    />
  );
};

export default Tooltip;
